<template>
  <!-- Default Input -->
  <b-form-input
    class="dynamic-input-text"
    :plaintext="viewMode"
    :ref="'field-' + field.name"
    :name="field.name"
    :type="type"
    :id="field.name"
    :required="field.required"
    placeholder="..."
    :value="fieldValue"
  ></b-form-input>
</template>

<script>
export default {
  name: "DynamicformInputText",
  props: {
    field: {
      type: Object,
      default: null,
    },
    entity: {
      type: Object,
      default: null,
    },
    fieldValue: {
      type: [String,Number],
      default: null,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
  },
  computed: {},
};
</script>

<style lang="scss">
@import "../../sass/_variables.scss";

.dynamic-input-text {
  height: $form-component-height;
  border-radius: 3px;
  border: 1px solid $gray-300;
  color: $gray-550;

  &.form-control-plaintext {
    border: 0;
    border-bottom: 1px solid $gray-300;
    border-radius: 0;
    padding: 0.375rem 0.75rem;
  }

  &:focus {
    color: $black;
    background-color: #fff;
    border-color: $black;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DynamicForms/InputText.vue